import type { Dict } from "../types";

export const clientPortal: Dict = {
  en: {
    "history.hairdressers": "Employees",

    // BookingHistory
    "history.title": "My Appointments",
    "history.subtitle": "View and manage your upcoming and past appointments",
    "history.bookNew": "Book New",
    "history.signOut": "Sign Out",
    "history.noAppointments": "You don't have any appointments yet",
    "history.mergedAccount.title": "This account has been merged",
    "history.mergedAccount.body": "Your history is now under your other account. Please sign in with your other email address, or contact the salon for help.",
    "history.bookFirst": "Book Your First Appointment",
    "history.greeting": "Hello",
    "history.summary.at": "Your history at",
    "history.summary.atGeneric": "Your history",
    "history.summary.next": "Next appointment",
    "history.summary.tomorrow": "Tomorrow",
    "history.summary.balance": "Balance due",
    "history.summary.invoices": "invoices",
    "history.summary.loyalty": "Loyalty",
    "history.summary.visits": "visits",
    "history.summary.since": "since",
    "history.summary.pay": "Pay",
    "history.rail.invoices": "View my invoices",
    "history.past": "Past",
    "history.year.visits": "visits",
    "history.year.cancelled": "cancellation(s)",
    "history.actions.reschedule": "Reschedule",
    "history.actions.cancel": "Cancel",
    "history.actions.rebook": "Book again",
    "history.locked": "Too late to change this online. Please call the salon.",
    "history.cancelledOn": "Cancelled on",
    "history.cancelledByYou": "Cancelled by you on",
    "history.cancelledBySalon": "Cancelled by the salon on",
    "history.upcoming": "Upcoming",
    "history.pastAppointments": "Past Appointments",
    "history.date": "Date",
    "history.time": "Time",
    "history.service": "Service",
    "history.services": "Services",
    "history.hairdresser": "Employee",
    "history.notes": "Notes",
    "history.cancel.title": "Cancel Appointment?",
    "history.cancel.description": "Are you sure you want to cancel this appointment? The salon will be notified.",
    "history.cancel.keep": "Keep Appointment",
    "history.cancel.confirm": "Cancel Appointment",
    "history.cancel.success": "Success",
    "history.cancel.successDesc": "Appointment cancelled successfully",
    "history.cancel.error": "Error",
    "history.cancel.errorDesc": "Failed to cancel appointment",
    "history.cancel.contactSalon": "This appointment can't be cancelled online right now. Please contact the salon to cancel it.",
    "history.lockedNotice": "Cancellations and rescheduling are unavailable less than {hours} h before the appointment. Please contact the salon for any change.",
    "history.lockedToast.title": "Action unavailable",
    "history.lockedToast.description": "Cancellations and rescheduling are unavailable less than {hours} h before the appointment. Please contact the salon for any change.",
    "history.status.confirmed": "Confirmed",
    "history.status.pending": "Pending Approval",
    "history.status.cancelled": "Cancelled",
    "history.status.completed": "Completed",
    "history.multiService": "Multi-Service",
    "history.nServices": "{n} services",
    "history.total": "Total",
    "history.bookAgain": "Book Again",
    "history.loadMore": "Load more",
    "history.remaining": "remaining",
    // J-3 / J-4 — « Mes factures » dans le portail client.
    "history.invoices.title": "My Invoices",
    "history.invoices.totalDue": "Balance due",
    "history.invoices.settledTitle": "Settled invoices",
    "history.invoices.settledLabel": "Paid",
    "history.invoices.refundedLabel": "Refunded",
    "history.invoices.pay": "Pay",
    "history.invoices.payPending": "Opening…",
    "history.invoices.payError": "Payment could not be started. Please try again or contact the salon.",
    "history.invoices.readError": "Your invoices cannot be displayed right now. Please try again in a moment.",

    // Booking History Notifications
    "bookingHistory.warning": "Warning",
    "bookingHistory.emailNotSent": "Failed to send confirmation email",
    "appointment.staffNoteFromStylist": "Note from your stylist",
  },
  fr: {
    "history.hairdressers": "Employé(e)s",

    // BookingHistory
    "history.title": "Mes rendez-vous",
    "history.subtitle": "Consultez et gérez vos rendez-vous à venir et passés",
    "history.bookNew": "Nouvelle réservation",
    "history.signOut": "Se déconnecter",
    "history.noAppointments": "Vous n'avez pas encore de rendez-vous",
    "history.mergedAccount.title": "Ce compte a été fusionné",
    "history.mergedAccount.body": "Votre historique se trouve maintenant sous votre autre compte. Connectez-vous avec votre autre adresse courriel, ou contactez le salon pour de l'aide.",
    "history.bookFirst": "Réservez votre premier rendez-vous",
    "history.greeting": "Bonjour",
    "history.summary.at": "Votre suivi chez",
    "history.summary.atGeneric": "Votre suivi",
    "history.summary.next": "Prochain rendez-vous",
    "history.summary.tomorrow": "Demain",
    "history.summary.balance": "Solde à payer",
    "history.summary.invoices": "factures",
    "history.summary.loyalty": "Fidélité",
    "history.summary.visits": "visites",
    "history.summary.since": "depuis",
    "history.summary.pay": "Payer",
    "history.rail.invoices": "Voir mes factures",
    "history.past": "Passés",
    "history.year.visits": "visites",
    "history.year.cancelled": "annulation(s)",
    "history.actions.reschedule": "Reporter",
    "history.actions.cancel": "Annuler",
    "history.actions.rebook": "Réserver à nouveau",
    "history.locked": "Trop tard pour modifier en ligne. Appelez le salon.",
    "history.cancelledOn": "Annulé le",
    "history.cancelledByYou": "Annulé par vous le",
    "history.cancelledBySalon": "Annulé par le salon le",
    "history.upcoming": "À venir",
    "history.pastAppointments": "Rendez-vous passés",
    "history.date": "Date",
    "history.time": "Heure",
    "history.service": "Service",
    "history.services": "Services",
    "history.hairdresser": "Employé(e)",
    "history.notes": "Notes",
    "history.cancel.title": "Annuler le rendez-vous ?",
    "history.cancel.description": "Êtes-vous sûr de vouloir annuler ce rendez-vous ? Le salon sera informé.",
    "history.cancel.keep": "Conserver le rendez-vous",
    "history.cancel.confirm": "Annuler le rendez-vous",
    "history.cancel.success": "Succès",
    "history.cancel.successDesc": "Rendez-vous annulé avec succès",
    "history.cancel.error": "Erreur",
    "history.cancel.errorDesc": "Impossible d'annuler le rendez-vous",
    "history.cancel.contactSalon": "Ce rendez-vous ne peut pas être annulé en ligne pour le moment. Communiquez avec le salon pour l'annuler.",
    "history.lockedNotice": "Annulation et report indisponibles moins de {hours} h avant le rendez-vous. Contactez le salon pour toute modification.",
    "history.lockedToast.title": "Action indisponible",
    "history.lockedToast.description": "Annulation et report indisponibles moins de {hours} h avant le rendez-vous. Contactez le salon pour toute modification.",
    "history.status.confirmed": "Confirmé",
    "history.status.pending": "En attente d'approbation",
    "history.status.cancelled": "Annulé",
    "history.status.completed": "Terminé",
    "history.multiService": "Multi-Service",
    "history.nServices": "{n} services",
    "history.total": "Total",
    "history.bookAgain": "Réserver à nouveau",
    "history.loadMore": "Charger plus",
    "history.remaining": "restants",
    // J-3 / J-4 — « Mes factures » dans le portail client.
    "history.invoices.title": "Mes factures",
    "history.invoices.totalDue": "Solde dû",
    "history.invoices.settledTitle": "Factures réglées",
    "history.invoices.settledLabel": "Payée",
    "history.invoices.refundedLabel": "Remboursée",
    "history.invoices.pay": "Payer",
    "history.invoices.payPending": "Ouverture…",
    "history.invoices.payError": "Paiement impossible pour le moment. Réessayez ou communiquez avec le salon.",
    "history.invoices.readError": "Impossible d’afficher vos factures pour le moment. Réessayez dans un instant.",

    // Booking History Notifications
    "bookingHistory.warning": "Avertissement",
    "bookingHistory.emailNotSent": "Impossible d'envoyer le courriel de confirmation",
    "appointment.staffNoteFromStylist": "Note de votre employé",
  },
};
